var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 17,
    r: 12,
    stroke: "#F6F6EB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4235 10.1584C11.894 15.366 9.3083 23.5508 9.3083 23.5508C9.3083 23.5508 15.0854 17.2086 19.8488 15.0227C20.0818 14.9141 20.2081 14.6952 20.1858 14.4392C19.926 10.5932 21.4588 6.59075 24.0041 3.95098L18.9343 1.02394C17.9391 4.55867 15.2392 7.88731 11.7604 9.5748C11.538 9.66522 11.4012 9.9023 11.4235 10.1584Z",
    fill: "#D4423E",
    stroke: "#F6F6EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31836 23.5325L15.3935 13.01",
    stroke: "#F6F6EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6359 12.0375C14.9514 11.4911 15.6502 11.3038 16.1966 11.6193C16.7431 11.9348 16.9303 12.6336 16.6148 13.18C16.2993 13.7265 15.6006 13.9137 15.0541 13.5982C14.5077 13.2827 14.3204 12.584 14.6359 12.0375Z",
    fill: "white",
    stroke: "#F6F6EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.3090bfac5b4ff01e0f48a9264f86b7c8.svg";
export { ForwardRef as ReactComponent };